import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useState } from "react";
import { createProgramFolder } from "../../../../services/program";
import { ProgramFolder } from "../../../../interfaces/program";

interface ProgramFolderNewProps {
    program_id: number;
    parent_folder_id: number | null;
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function ProgramFolderNew(props: ProgramFolderNewProps) {

    const handleSave = (event: any) => {
        event.preventDefault();

        const body: any = {
            program_id: props.program_id,
            name: event.target.name.value,
            description: event.target.description.value
        }

        if (props.parent_folder_id !== null) {
            body.parent_folder_id = props.parent_folder_id;
        }

        createProgramFolder(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    return (
        <Modal className="folder-new-container" show={ true }
            onHide={ handleClose }>
            <Modal.Header closeButton>
                <Modal.Title>
                    { props.parent_folder_id === null ? t("New folder") : t("New subfolder") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={ handleSave }>
                    <div className="fields">
                        <Form.Group className="mb-3" controlId="name">
                            <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                            <Form.Control type="text" name="name" required />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="description">
                            <Form.Label>{ t("description") }</Form.Label>
                            <Form.Control name="description" as="textarea" />
                        </Form.Group>
                    </div>
                    <div className="actions">
                        <Button type="submit" variant="primary">
                            { t("Save") }
                        </Button>
                        <Button variant="secondary" onClick={ handleClose }>
                            { t("Close") }
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}
